import { render, staticRenderFns } from "./HangMan.vue?vue&type=template&id=7325504e&scoped=true&"
import script from "./HangMan.vue?vue&type=script&lang=js&"
export * from "./HangMan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7325504e",
  null
  
)

export default component.exports